// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"711":"72c22146","850":"a8bcd759"}[chunkId] + ".css";
};